import { useAuth } from '../lib/auth'

export function ImpersonationBanner() {
  const { isImpersonating, user, stopImpersonation } = useAuth()

  if (!isImpersonating || !user) return null

  return (
    <div className="flex items-center justify-center gap-3 bg-warning-600 px-4 py-2 text-sm font-medium text-white">
      <span>
        Admin view. Viewing as <strong>{user.email}</strong> ({user.org_name}). Changes are blocked.
      </span>
      <button
        onClick={() => stopImpersonation()}
        className="rounded-md bg-white/20 px-2.5 py-1 text-xs font-semibold hover:bg-white/30"
      >
        Stop impersonating
      </button>
    </div>
  )
}
